import React, { Component } from "react";
import map from "lodash/map";
import Member from "./Member";

class Members extends Component {
  render() {
    const { members } = this.props;
    members.sort((a, b) => b.points - a.points);
    return (
      <div className="members">
        <h2 className="members__heading">Current sprint points</h2>
        {map(members, (member, i) => (
          <Member
            key={i}
            fullName={member.fullName}
            avatarHash={member.avatarHash}
            points={member.points}
          />
        ))}
      </div>
    );
  }
}

export default Members;



// WEBPACK FOOTER //
// ./src/Members.js